import type { SensorAutoSaveStatus } from "../../utils/sensor/sensor-auto-save";

type EditAutoSaveStatusInput = {
	canPersist: boolean;
	fingerprint: string;
	hasDraft: boolean;
	hasSavedThisSession: boolean;
	isPending: boolean;
	lastSavedFingerprint: null | string;
};

/**
 * Shared sensor/zone auto-save pill status from draft fingerprint + pending flag.
 */
export const resolveEditAutoSaveStatus = ({
	canPersist,
	fingerprint,
	hasDraft,
	hasSavedThisSession,
	isPending,
	lastSavedFingerprint,
}: EditAutoSaveStatusInput): SensorAutoSaveStatus => {
	if (!hasDraft) return "idle";
	if (isPending) return "saving";

	if (hasSavedThisSession && fingerprint === lastSavedFingerprint) {
		return "saved";
	}

	if (fingerprint !== lastSavedFingerprint && canPersist) {
		return "pending";
	}

	return "idle";
};
